import { themed } from "@smartsheet/sds-theme-internal";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { BaseButtonStyledProps } from "../types";
import { borderTheme } from "./getButtonBorderRadius";

const focusRingTheme = themed({
    offset: {
        "lodestar-light": 2,
        "ursa-light": 1,
    },
});

export const getButtonFocusRingStyles = ({ themeMode, size }: BaseButtonStyledProps): string => {
    return createFocusRingStyles({
        gap: focusRingTheme.offset(themeMode),
        componentBorderWidth: 1,
        componentRadius: borderTheme[size](themeMode),
        theme: themeMode,
    });
};
